import { useEffect } from "react";

export const GOOGLE_TAG_ID = process.env.REACT_APP_GOOGLE_TAG_ID || "";
export const GOOGLE_EVENT_ID = process.env.REACT_APP_GOOGLE_EVENT_ID || "";

type ReturnType = {
  fireConversionEvent: (eventId: string) => void;
};

export default (conversionId?: string): ReturnType => {
  useEffect(() => {
    if (!conversionId) {
      console.warn("No conversion ID provided to useGoogleTracking");
      return;
    }
    let script: HTMLScriptElement | null = null;
    if (!document.querySelector(`script[src*="${conversionId}"]`)) {
      // Load the Google Tag Manager tracking script dynamically
      script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${conversionId}`;
      document.head.appendChild(script);
    }

    // Setup Google Tag Manager setup script dynamically
    const setupScript = document.createElement("script");
    setupScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${conversionId}');
    `;
    document.head.appendChild(setupScript);

    // Cleanup on component unmount
    return () => {
      if (script) {
        document.head.removeChild(script);
      }
      document.head.removeChild(setupScript);
    };
  }, [conversionId]);

  const fireConversionEvent = (eventId: string) => {
    if (!eventId) {
      console.warn("No event ID provided to fireConversionEvent");
      return;
    }
    // Explicitly cast window to a type that includes gtag for the scope of this function.
    // This resolves the TypeScript error about 'gtag' not existing on 'Window'.
    // Ideally, 'gtag' should be declared globally (e.g., in a .d.ts file),
    // but this local cast is a common way to handle it for specific usages.
    const windowWithGtag = window as Window & {
      gtag?: (
        command: string,
        action: string,
        params: { send_to: string },
      ) => void;
    };

    if (typeof windowWithGtag.gtag === "function") {
      // If gtag is defined and is a function, call it.
      windowWithGtag.gtag("event", "conversion", { send_to: eventId });
    } else {
      console.error(
        "window.gtag function is not defined. Google Analytics conversion event could not be sent.",
      );
    }
  };
  return { fireConversionEvent };
};
